export const SURVEY_SCALE_PATH = "/surveys-editor/scales/:id";
